<template>
  <div class='ex-container'>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollDisabled"
      infinite-scroll-immediate-check="false">
        <div class='fdetail'>
          <div class='num'>{{dataInfo.Amount | toFixed}}</div>
          <div class='fs-26'>元</div>
        </div>
        <div class='padd-20-30' @click='showPicker'>
          <div class='fs-34 flex align-items'>
            <template v-if="year || month">
              {{year}}年
              {{month}}月
            </template>
            <template v-else>
              {{dataInfo.NowDate | formatTime('YYYY')}}年
              {{dataInfo.NowDate | formatTime('MM')}}月
            </template>
            <div class='icon-down-trangle-copy iconfont fs-34'></div>
          </div>
          <div class='t_999 fs-26'>本月提成 ￥{{dataInfo.AmountMonth | toFixed}}</div>
        </div>
        <div class='b_fff f_list'>
          <div
            class='fdetail_list'
            v-for="(item, index) in dataList" :key="index">
              <div class='list_left flex'>
                <div class="list_icon icon-jianzhiqianbao iconfont" :class="[item.Ftype === 1 ? 'b_f05c61' : 'b_409EFf']"></div>
                <div class='list_txt'>
                  <div v-if="item.Ftype === 1">{{item.Fnickname2 | formatNickName}} 完成订单</div>
                  <div v-if="item.Ftype === 2">兑换提成</div>
                  <div class='fs-26 t_999'>{{item.FCreateTime | formatTime('MM')}}月{{item.FCreateTime | formatTime('DD')}}日 {{item.FCreateTime | formatTime('HH:mm')}}</div>
                </div>
              </div>
              <div
                :class="{'list_right': true, 't_f05c61': item.Ftype === 1}"
              >{{item.Ftype === 1 ? '+' : '-'}}{{item.FMoney | toFixed}}</div>
          </div>
        </div>
        <segment-line
          v-if="!haveMore"
          line-text="没有更多记录了">
        </segment-line>
        <segment-line
          v-if="haveMore"
          line-text="正在加载"
          :is-load="true">
        </segment-line>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom">
      <div>
        <div class='picker-btn'>
          <span class='cancel' @click='cancelClick'>取消</span>
          <span @click='sureClick'>确定</span>
        </div>
        <mt-picker :slots="timeSlots" @change="onValuesChange"></mt-picker>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { Indicator, Toast } from 'mint-ui'
import SegmentLine from '@/components/puppetComponent/SegementLine'
import { MyConcessionInfo } from '@/api/partner'
export default {
  data () {
    return {
      haveMore: true,
      scrollDisabled: false,
      years: [],
      year: '',
      months: [],
      month: '',
      dataInfo: {},
      dataList: [],
      currentPage: 1,
      page: 1,
      pageCount: 1,
      // 选中的值
      pickerSelectVal: [],
      // 开始与结束日期
      startDate: new Date(),
      endDate: new Date(),
      popupVisible: false,
      timeSlots: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }, {
          flex: 1,
          values: [],
          className: 'slot2',
          textAlign: 'center'
        }
      ]
    }
  },
  mounted () {
    let date = new Date()
    let startYear = date.getFullYear()
    let startMonth = date.getMonth() + 1
    let endMonth = startMonth
    this.fetchData(res => {
      if (res.FirstYear) {
        startYear = res.FirstYear
      }
      if (res.FirstMonth) {
        startMonth = res.FirstMonth
        if (startMonth > endMonth) {
          [startMonth, endMonth] = [endMonth, startMonth]
        }
      }
      for (let i = startYear; i <= date.getFullYear(); i++) {
        this.years.push(i)
      }
      for (let i = startMonth; i <= endMonth; i++) {
        this.months.push(i)
      }
      // 设置默认选中当前日期
      let dataTime = ''
      let dateNow = new Date()
      let yearIndex = 9999
      let monthIndex = date.getMonth()
      if (res.NowDate) {
        dataTime = res.NowDate.replace(/\D+/ig, '')
        dateNow = new Date(parseInt(dataTime))
      }
      yearIndex = this.years.findIndex((i) => i === dateNow.getFullYear())
      monthIndex = this.months.findIndex((i) => i === dateNow.getMonth() + 1)
      this.timeSlots[0].values = this.years
      this.timeSlots[0].defaultIndex = yearIndex
      this.timeSlots[1].values = this.months
      this.timeSlots[1].defaultIndex = monthIndex
    })
  },
  methods: {
    fetchData (fn) {
      let { year, month, currentPage } = this
      let params = {
        Year: year,
        Month: month,
        page: currentPage
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      MyConcessionInfo(params).then(res => {
        this.dataInfo = res
        this.dataList = [...this.dataList, ...res.DataList]
        this.page = res.PaginationViewModel.Page
        this.pageCount = res.PaginationViewModel.PageCount
        if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
          this.haveMore = false
        }
        if (fn) {
          fn(res)
        }
        this.scrollDisabled = false
        Indicator.close()
      }).catch(res => {
        this.haveMore = false
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    // 打开
    showPicker () {
      this.popupVisible = true
    },
    // 关闭
    cancelClick () {
      this.popupVisible = false
    },
    // 修改
    onValuesChange (picker, values) {
      this.pickerSelectVal = values
    },
    // 确定
    sureClick () {
      this.popupVisible = false
      this.year = this.pickerSelectVal[0]
      this.month = this.pickerSelectVal[1]
      this.dataList = []
      this.currentPage = 1
      this.fetchData()
    },
    loadMore () {
      let { currentPage, page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage = currentPage + 1
      this.haveMore = true
      this.fetchData()
    },
    parseTime (val) {
      return val < 10 ? '0' + val : val
    }
  },
  components: {
    SegmentLine
  },
  filters: {
    toFixed (val) {
      if (!val) {
        return '0.00'
      } else {
        return parseFloat(val).toFixed(2)
      }
    },
    formatTime: function (val, split) {
      if (!val) return
      switch (split) {
        case 'YYYY':
          return moment(val).year()
        case 'MM':
          return moment(val).month() + 1
        case 'DD':
          return moment(val).date()
        case 'HH:mm':
          return moment(val).format('HH:mm')
        default:
          return '--'
      }
    },
    formatNickName: function (val) {
      if (val.length > 4) {
        val = val.substring(0, 4) + '...'
        return val
      } else {
        return val
      }
    }
  }
}
</script>

<style scoped="scoped">
.mint-popup-bottom{
  width: 100%;
}
.ex-container{
  height: 100vh;
  width:100%;
  overflow:scroll;
  background:#f5f5f5;
  font-size:15px;
}
.fdetail{
  border-top: 1px solid #f6f6f6;
  background: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding:20px 0;
}
.padd-20-30{
  padding: 10px 15px;
  box-sizing: border-box;
}
.num{
  font-size: 40px;
  line-height: 40px;
}
.t_center{
  text-align: center;
}
.f_list{
  padding: 0 15px;
}
.f_list .fdetail_list:last-child{
  border-bottom: 0;
}
.fdetail_list{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f6f6f6;
}
.list_icon{
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 100%;
  color: #fff;
  margin-right: 15px;
  font-size: 18px;
}
.b_f05c61{
  background: #f05c61;
}
.b_409EFf{
  background: #409EFf;
}
.t_f05c61{
  color: #f05c61;
}
.list_right{
  font-size: 17px;
}
/* picker-view */
.pick{
  overflow: hidden;
  z-index: 999;
}
.picker-view-main{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 200px;
  background: #fff;
  z-index: 1000;
  animation-fill-mode: backwards;
  animation: pickerAnim .3s ease-in-out;
}
.picker-view-main view{
  text-align: center;
  line-height: 50px;
}
.picker-btn{
  width: 100%;
  height: 40px;
  background: #fff;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 16px;
  animation-fill-mode: backwards;
  animation: btnAnim .3s ease-in-out;
}
.picker-btn span {
  padding: 0 15px;
}
.picker-btn .cancel{
  color: #999
}
.p-mask{
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  animation-fill-mode: backwards;
  animation: maskAnim .2s ease-in;
}
@keyframes maskAnim{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
@-webkit-keyframes maskAnim{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
@keyframes pickerAnim{
  0%{
    bottom: -200px;
  }
  100%{
    bottom: 0;
  }
}
@-webkit-keyframes pickerAnim{
  0%{
    bottom: -200px;
  }
  100%{
    bottom: 0;
  }
}
@keyframes btnAnim{
  0%{
    bottom: -240px
  }
  100%{
    bottom: 200px;
  }
}
@-webkit-keyframes btnAnim{
  0%{
    bottom: -240px
  }
  100%{
    bottom: 200px;
  }
}
</style>
